import { Component, ViewChild } from "@angular/core";
import { NavController, NavParams, Content } from "ionic-angular";

import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

@Component({
  selector: "page-solicitud",
  templateUrl: "solicitud.html"
})
export class SolicitudPage {
  @ViewChild(Content) content: Content;

  data: any = {};

  solicitud: any = {};
  respuesta = "";
  hilo = [];

  tipossolicitud = this.global.CONFIGURA["tipos_solicitud"];
  estadossolicitud = this.global.CONFIGURA["estados_solicitud"];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public conector: ConectorProvider,
    public global: GlobalProvider
  ) {
    this.data = {
      background: "assets/images/background/39.jpg"
    };

    this.solicitud = this.navParams.data["solicitud"];
    this.hilo = this.solicitud.hilo.reverse();
    this.solicitud.tiponombre = this.tipossolicitud[this.solicitud.tipo];
    this.solicitud.estadonombre = this.estadossolicitud[this.solicitud.estado];

    let TextLOG =
      "Acceso a SOLICITUD  id:" +
      this.solicitud.id +
      " - Tipo: (" +
      this.solicitud.tipo +
      ") " +
      this.solicitud.tiponombre +
      "| Estado: (" +
      this.solicitud.estado +
      ") " +
      this.solicitud.estadonombre;
    console.log(this.solicitud);
    this.conector.registraractividad(TextLOG).subscribe(data => {
      console.log("registramos Actividad", TextLOG);
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad SolicitudPage");
    this.content.scrollToBottom();
  }

  enviarRespuesta() {
    if (this.respuesta !== "") {
      this.conector
        .responderSolicitud(this.solicitud.id, this.respuesta)
        .subscribe(resp => {
          console.log("Respuesta Solicitud", resp);
          this.solicitud = resp["solicitud"];
          this.hilo = this.solicitud.hilo.reverse();
          this.respuesta = "";
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/solicitud/solicitud.ts